module.exports = "\r\n<ng-multiselect-dropdown\r\n  [settings]=\"dropdownSettings\"\r\n  [data]=\"dropdownList\"\r\n  [(ngModel)]=\"selectedItems\"\r\n  (ngModelChange)=\"emitByType()\"\r\n  *ngIf=\"isLoad\"\r\n  >\r\n</ng-multiselect-dropdown>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/multi-select-dropdown/provider-multi-select/provider-multi-select.component.html
// module id = 2345
// module chunks = 66